<div class="bg-header-soft-color d-flex align-items-center">
  <ng-container [ngTemplateOutlet]="customTitleTemplate() || defaultTitle">
  </ng-container>
  <ng-template #defaultTitle>
    <div class="flex-grow-1">
      <h4 mat-dialog-title class="s-mb-3 fw-bold fs-5 c-white">
        {{ title() }}
      </h4>
    </div>
  </ng-template>
  <div>
    <button
      type="button"
      mat-icon-button
      aria-label="close"
      [matTooltip]="'close' | transloco"
      mat-dialog-close
      [disabled]="!allowClose()"
    >
      <mat-icon color="primary">close</mat-icon>
    </button>
  </div>
</div>
@if(contentTemplate()){
<mat-dialog-content>
  <ng-container [ngTemplateOutlet]="contentTemplate()"> </ng-container>
</mat-dialog-content>
}
<mat-dialog-actions align="end" class="d-flex gap-2">
  <button
    class="close-btn"
    cdkFocusInitial
    mat-stroked-button
    [matTooltip]="'close' | transloco"
    mat-dialog-close
    [disabled]="!allowClose()"
  >
    <mat-icon class="s-me-1">close</mat-icon>
    {{ "close" | transloco }}
  </button>
  @if(actionButtonsTemplate()){
  <ng-container [ngTemplateOutlet]="actionButtonsTemplate()"> </ng-container>
  }
</mat-dialog-actions>
